import React from 'react'
import { ProjectionsContainer } from '../../components/projections/ProjectionsContainer'

export const Projections = () => {
  return (
    <ProjectionsContainer/>
  )
}
